// utils/facebookPixel.tsx
let isPixelInitialized = false;

export const initFacebookPixel = (pixelId) => {
  if (typeof window === 'undefined' || isPixelInitialized) return;
  // Inject Facebook Pixel script
  ;(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq?.('init', pixelId);
  window.fbq?.('track', 'PageView');
  isPixelInitialized = true;
};
export const trackFacebookEvent = (eventName, data = {}) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('trackCustom', eventName, data);
  }
};

// Optional component: <FacebookPixelNoScript />
export const FacebookPixelNoScript = () => (
  <noscript>
    <img
      height="1"
      width="1"
      style={{ display: 'none' }}
      src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`}
      alt=""
    />
  </noscript>
);